import { clearUserScopedClientState } from "./clientSessionLifecycle";
import {
    accountDeletionService,
} from "./accountDeletionService";
import {
    ACCOUNT_DELETION_ROUTES,
    replaceWithAccountDeletionDocument,
} from "../constants/accountDeletionRoutes";

const UUID_V4_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;
const ACCEPTED_STATUSES = new Set(["DEACTIVATING", "RECOVERY_WINDOW"]);

const hasTimestamp = (value) => (
    typeof value === "string" && Number.isFinite(Date.parse(value))
);

export const isAcceptedAccountDeletionReceipt = (receipt) => (
    receipt
    && typeof receipt === "object"
    && typeof receipt.requestId === "string"
    && UUID_V4_PATTERN.test(receipt.requestId)
    && ACCEPTED_STATUSES.has(receipt.status)
    && hasTimestamp(receipt.requestedAt)
    && hasTimestamp(receipt.recoverableUntil)
    && Date.parse(receipt.recoverableUntil) > Date.parse(receipt.requestedAt)
);

export const submitAccountDeletion = async ({
    csrfToken,
    reauthToken,
    idempotencyKey,
    dispatch,
}) => {
    const receipt = await accountDeletionService.createDeletionRequest({
        confirmation: "DELETE",
        csrfToken,
        reauthToken,
        idempotencyKey,
    });
    if (!isAcceptedAccountDeletionReceipt(receipt)) {
        throw new TypeError("Account deletion acceptance receipt is invalid");
    }
    await clearUserScopedClientState({ dispatch });
    replaceWithAccountDeletionDocument(ACCOUNT_DELETION_ROUTES.status);
};
